/**
 * @generated SignedSource<<e0d639577ae3346348106126f6951852>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Certificate = "FIRST" | "FOLLOW_UP";
import { FragmentRefs } from "relay-runtime";
export type deLegalGuardianAttestationFragment$data = {
  readonly birthDate: any;
  readonly certificate: Certificate;
  readonly concludedAt: string | null;
  readonly concludedBy: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly durationFrom: any;
  readonly durationTo: any;
  readonly fileId: string | null;
  readonly fileMetadata: {
    readonly documentType: string;
    readonly extension: string;
    readonly lengthInKilobytes: number;
  } | null;
  readonly firstName: string;
  readonly id: string;
  readonly lastName: string;
  readonly progressNoteId: string;
  readonly signedAt: string | null;
  readonly signedBy: string | null;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly " $fragmentType": "deLegalGuardianAttestationFragment";
};
export type deLegalGuardianAttestationFragment$key = {
  readonly " $data"?: deLegalGuardianAttestationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deLegalGuardianAttestationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deLegalGuardianAttestationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "certificate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_AttestationGuardian",
  "abstractKey": null
};

(node as any).hash = "a959fc32c29969e87d5d1fb863821e67";

export default node;
